<aside class="rp-dr" role="complementary" [attr.aria-label]="name() + ', ' + row().post.deliverableLabel + ' on ' + platform()">
  <header class="mm-dh">
    <span class="rp-av">
      @if (row().creator?.avatarUrl) {<img [src]="row().creator!.avatarUrl!" alt="" />} @else {{{ avatarInitials() }}}
    </span>
    <div class="flex min-w-0 flex-1 flex-col gap-0.5">
      <b class="truncate font-(family-name:--font-display) text-[22px] leading-none font-bold">{{ name() }}</b>
      <span class="mo-sub truncate">
        @if (followers(); as f) {{{ f }} followers · }{{ row().post.deliverableLabel }} on {{ platform() }}
      </span>
    </div>
    <span class="cnt">{{ index() + 1 }} of {{ count() }}</span>
    <button type="button" class="rp-ib" aria-label="Previous post" [disabled]="index() === 0" (click)="step.emit(-1)">
      <mba-icon name="chevron-up" size="size-4" />
    </button>
    <button type="button" class="rp-ib" aria-label="Next post" [disabled]="index() >= count() - 1" (click)="step.emit(1)">
      <mba-icon name="chevron-down" size="size-4" />
    </button>
    <button #closeBtn type="button" class="rp-ib" aria-label="Close" (click)="close.emit()">
      <mba-icon name="x" size="size-4" />
    </button>
  </header>

  <div class="mm-db">
    <div class="mm-dtop">
      <div class="rp-prev">
        @if (row().post.thumbnailUrl) {<img [src]="row().post.thumbnailUrl!" alt="" />}
        @if (row().post.platform) {
        <span class="rp-ppill"><img [src]="logos[row().post.platform!]" alt="" />{{ platform() }}</span>
        }
        <span class="rp-play"><mba-icon name="play" size="size-5" /></span>
      </div>
      <div class="flex min-w-0 flex-col gap-3">
        @if (statsLoading()) {
        <span class="rp-sk w-full"></span><span class="rp-sk w-3/4"></span>
        } @else if (row().stats?.caption) {
        <p class="rp-cap">{{ row().stats!.caption }}</p>
        }
        <dl class="rp-kv">
          <dt>Posted</dt><dd>{{ posted() }}</dd>
          <dt>Refreshed</dt><dd>{{ statsLoading() ? '…' : refreshed() }}</dd>
          <dt>Video</dt><dd>{{ row().post.deliverableLabel }}</dd>
          <dt>Disclosure</dt>
          <dd>
            @if (statsLoading()) { … }
            @else if (row().stats?.disclosureFound === true) {<span class="rp-ok"><mba-icon name="check-circle" size="size-3.5" />#ad found</span>}
            @else if (row().stats?.disclosureFound === false) {<span class="rp-od"><mba-icon name="alert-circle" size="size-3.5" />Not found</span>}
            @else { Not checked }
          </dd>
          <dt>Source</dt>
          <dd>
            @if (row().stats?.source === 'ultra') {<span class="rp-src us">Ultra</span>}
            @else if (row().stats?.source === 'super') {<span class="rp-src ss">Super</span>}
            @else { – }
          </dd>
        </dl>
        @if (row().post.url) {
        <a class="rp-open" [href]="row().post.url!" target="_blank" rel="noopener">Open on {{ platform() }}<mba-icon name="external-link" size="size-3.5" /></a>
        }
      </div>
    </div>

    <div class="mm-sgrid">
      @for (s of stats(); track s.label) {
      <div>
        <span class="mo-k">{{ s.label }}</span>
        @if (statsLoading()) {<span class="rp-sk mt-1 w-16"></span>} @else {<b>{{ s.value }}</b>}
      </div>
      }
    </div>

    <section class="flex flex-col gap-2">
      <div class="flex items-baseline justify-between gap-2">
        <h3 class="bb-h">Views Since Posting</h3>
        @if (spark(); as sp) {<span class="mo-sub">{{ sp.caption }}</span>}
      </div>
      @if (seriesLoading()) {
      <span class="rp-sk h-16 w-full"></span>
      } @else if (spark(); as sp) {
      <svg class="mm-spark" [attr.viewBox]="'0 0 ' + sparkW + ' ' + sparkH" preserveAspectRatio="none" role="img"
        [attr.aria-label]="'Views since posting: ' + sp.caption">
        <path [attr.d]="sp.area" fill="var(--app-accent-soft)" />
        <path [attr.d]="sp.line" fill="none" stroke="var(--app-accent)" stroke-width="2" vector-effect="non-scaling-stroke" />
      </svg>
      } @else {
      <span class="mo-sub">No daily history for this post yet.</span>
      }
    </section>

    @if (compare(); as c) {
    <section class="rp-cmp">
      <h3 class="bb-h">How It Compares</h3>
      @if (c.verdict) {
      <span class="rp-verdict" [class.up]="c.verdict.up" [class.dn]="!c.verdict.up">
        <mba-icon [name]="c.verdict.up ? 'arrow-up' : 'arrow-down'" size="size-3.5" />{{ c.verdict.text }}
      </span>
      }
      @for (b of c.bars; track b.label) {
      <div class="rp-cr">
        <span class="l">{{ b.label }}</span>
        <span class="tr"><i [style.width.%]="b.width" [style.background]="b.color"></i></span>
        <b>{{ b.text }}</b>
      </div>
      }
    </section>
    }

    <p class="mm-note">
      {{ sourceNote() }} Ultra Social is the source of truth; Super Social only fills gaps.
      Engagement rate is likes, comments, shares and saves divided by views.
    </p>
  </div>

  <footer class="mm-df">
    @if (row().post.url) {
    <a class="rp-btn primary" [href]="row().post.url!" target="_blank" rel="noopener"><mba-icon name="external-link" size="size-4" />Open post</a>
    }
  </footer>
</aside>
